module.exports = __webpack_public_path__ + "img/img24.fd79ed7c.svg";